/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Components */
import ChannelLaneSkeleton from '../ChannelLaneSkeleton';

function EpgEmptyChannelMessage({
  withoutFilter,
  emptyChannelsMessage,
}) {
  return (
    <>
      <div className="dtv-html5-c-epg__channels-container dtv-html5-c-epg__empty-message">
        <ChannelLaneSkeleton
          withoutFilter={withoutFilter}
          emptyChannelsMessage
        />
        <ChannelLaneSkeleton
          withoutFilter={withoutFilter}
          emptyChannelsMessage
        />
        <ChannelLaneSkeleton
          withoutFilter={withoutFilter}
          emptyChannelsMessage
        />
        <ChannelLaneSkeleton
          withoutFilter={withoutFilter}
          emptyChannelsMessage
        />
        <ChannelLaneSkeleton
          withoutFilter={withoutFilter}
          emptyChannelsMessage
        />
      </div>
      <div className="dtv-html5-c-epg__empty-channels-message">
        <span className="dtv-html5-c-epg__empty-channels-message--title">
          {emptyChannelsMessage.title}
        </span>
        <span className="dtv-html5-c-epg__empty-channels-message--description">
          {emptyChannelsMessage.description}
        </span>
      </div>
    </>
  );
}

EpgEmptyChannelMessage.propTypes = {
  emptyChannelsMessage: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  withoutFilter: PropTypes.bool,
};

EpgEmptyChannelMessage.defaultProps = {
  emptyChannelsMessage: PropTypes.shape({
    title: '',
    description: '',
  }),
  withoutFilter: false,
};

export default memo(EpgEmptyChannelMessage);
